module.exports = __webpack_public_path__ + "assets_1775109859079/img/pic_7.731956bc.png";